<template>
  <div class="vascularPlant">
    <div class="vascularPlant-lg">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
        <el-descriptions-item label="采集日期" prop="collectTime">
          {{ infoContent.collectTime }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="区/县" prop="district">
          {{ infoContent.district }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
        </el-descriptions-item>
<!--        <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0" label="图片展示" span="3"  class="img">-->
<!--          &lt;!&ndash;         <template slot-scope="scope">&ndash;&gt;-->
<!--          <el-carousel  :interval="2000" arrow="always" class="carousel">-->
<!--            <el-carousel-item v-for="item in infoContent.pictureVideoFileList"-->
<!--                              :key="item.id">-->
<!--              <img :src="item.url" alt="" class="carousel-img">-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--          &lt;!&ndash;         </template>&ndash;&gt;-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
    </div>
    <div class="vascularPlant-sm">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
        <el-descriptions-item label="采集日期" prop="collectTime">
          {{ infoContent.collectTime }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="区/县" prop="district">
          {{ infoContent.district }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
        </el-descriptions-item>
<!--        <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0" label="图片展示" span="3"  class="img">-->
<!--          <el-carousel  :interval="2000" arrow="always" class="carousel">-->
<!--            <el-carousel-item v-for="item in infoContent.pictureVideoFileList"-->
<!--                              :key="item.id">-->
<!--              <img :src="item.url" alt="" class="carousel-img">-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
    </div>
  </div>

</template>

<script>
export default {
  name: "vascularPlant",
  props: {
    infoContent: Object,
    title: String
  }
}
</script>

<style scoped lang="scss">
.vascularPlant {
  .vascularPlant-lg {
    display: block;
  }
  .vascularPlant-sm {
    display: none;
  }
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center;
}
@media screen and (max-width: 576px) {
  .vascularPlant {
    .vascularPlant-lg {
      display: none;
    }
    .vascularPlant-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>